var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeIPTab === 'create')?_c('ip-whitelisting',{on:{"view":function($event){return _vm.setCurrentTab('view')}}}):_c('ip-address-list',{on:{"create":function($event){return _vm.setCurrentTab('create')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }